/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespMainContent_viewer$ref = any;
type SbRespNullSearchResults_viewer$ref = any;
type TradePromo_viewer$ref = any;
export type SbRespCollectionsComponents_viewer$ref = any;
export type SbRespCollectionsComponents_viewer = {
    readonly isBillboardAdEnabled: boolean | null;
    readonly isThinPageEnabled: boolean | null;
    readonly isMoreWaysToBrowseEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespNullSearchResults_viewer$ref & TradePromo_viewer$ref & SbRespMainContent_viewer$ref;
    readonly " $refType": SbRespCollectionsComponents_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
];
return {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isBillboardAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isThinPageEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_viewer",
      "args": null
    }
  ]
};
})();
(node as any).hash = '8f6cb1188bfb2f5b33536894eb12f4c3';
export default node;
